import React, { useEffect, useState } from "reactn";
import { useParams } from 'react-router-dom'
import { Row, Col, Form, Input, Button, Card, message, Alert, Select } from 'antd';
import { useHistory } from 'react-router-dom';
import { LeftOutlined } from "@ant-design/icons";
import { MediaWithQuestionsInput } from '../components'
import { doc, getDoc, setDoc } from "firebase/firestore";
import firebaseDb from '../firebase';
import { Link } from 'react-router-dom';
import { useCallback } from "react";
import api from '../service/index'
import { nanoid } from 'nanoid';

const QuestinSetDetail = (props) => {
    let params = useParams()
    let history = useHistory()
    let id = params.id !== "add" ? params.id : false;
    let newRecord = {
        lang: "TR",
        name: null,
    }

    let [data, setData] = useState(id ? {} : newRecord);
    let [answers, setAnswers] = useState();
    let [errors, setErrors] = useState([]);
    let [loading, setLoading] = useState(id ? true : false);
    let [validationCheck, setValidationCheck] = useState(false)
    let [correctAnswers, setCorrectAnswers] = useState(null);

    //onetime run
    useEffect(() => {
        if (id) {
            setLoading(true)
            get()
        }
    }, [id]);

    let get = async () => {
        let questionJson = {}
        await api.get("/rest/questionSet/getAnswers/" + id).then(({ data }) => {
            questionJson = data
        });

        const questionSetRef = doc(firebaseDb, "questionSet", id);
        const questionSetSnap = await getDoc(questionSetRef);

        if (questionSetSnap.exists()) {
            let fullData = {
                ...questionSetSnap.data(),
                id: questionSetSnap.id
            }
            fullData.questions.map(q => {
                for (const [key, value] of Object.entries(questionJson)) {
                    if (q.id === key) {
                        q.choices.map(c => {
                            if (c.id === value) {
                                c.correctAnswer = true
                            }
                            else {
                                c.correctAnswer = false
                            }
                        })
                    }
                }
            })
            setData(fullData)
            setLoading(false)
        }
    }

    let validate = useCallback(() => {
        let errors = {};

        if (data.lang == null)
            errors.lang = 'Zorunlu Alan!'

        if (data.name == null || data.name.length === 0)
            errors.name = 'Zorunlu Alan!'

        if (data.questions == null || data.questions < 1)
            errors.questions = 'Hiç soru girmediniz';

        else data.questions.forEach((q, i) => {
            if (q.type === "TextToText" || q.type === "TextToImage") {
                if (q.name == null || q.name.length < 1) {
                    errors.name = `Soru metni boş geçilemez (${i + 1}. soru)`;
                    errors.questions = `Soru metni boş geçilemez (${i + 1}. soru)`;
                }
            }
            if (q.type === "ImageToText") {
                if (q.media.url === "" || q.media.url.length < 1) {
                    errors.name = `Soru resmi boş geçilemez (${i + 1}. soru)`;
                    errors.questions = `Soru resmi boş geçilemez (${i + 1}. soru)`;
                }

            }
            if (q.choices.length < 2) {
                errors.name = `Yeterli soru seçeneği girmediniz (${i + 1}. soru)`;
                errors.questions = `Yeterli soru seçeneği girmediniz (${i + 1}. soru)`;
            }
            if (q.choices.length > 4) {
                errors.name = `En fazla 4 seçenek girebilirsiniz (${i + 1}. soru)`;
                errors.questions = `En fazla 4 seçenek girebilirsiniz (${i + 1}. soru)`;
            }
            let count = 0
            q.choices.forEach((c, t) => {
                if (c.correctAnswer) {
                    count = count + 1
                }
            })
            if (count > 1) {
                errors.name = `Bir tane doğru cevap olabilir. (${i + 1}. soru)`;
                errors.questions = `Bir tane doğru cevap olabilir.(${i + 1}. soru)`;
            }
            if (count == 0) {
                errors.name = `Doğru cevap seçiniz. (${i + 1}. soru)`;
                errors.questions = `Doğru cevap seçiniz.(${i + 1}. soru)`;
            }
        });
        errors.all = Object.getOwnPropertyNames(errors).map(n => errors[n]);
        errors.hasError = errors.all.length > 0;
        return errors;
    }, [data]);

    useEffect(() => { if (validationCheck) setErrors(validate()) }, [validationCheck, data, validate]);

    let save = async () => {
        setValidationCheck(true)
        let err = validate()
        if (err.hasError) {
            setErrors(err)
            window.scrollTo({ top: 20, behavior: 'smooth' });
        }
        else {
            let correctAnswers = {};
            data.questions.map((q, i) => {
                q.questionImageName = q.media.id
                q.choices.map((c, t) => {
                    if (c.correctAnswer) {
                        correctAnswers['' + q.id + ''] = c.id
                    }
                    delete c.correctAnswer
                })
            });

            if (id) {
                await setDoc(doc(firebaseDb, "questionSet", id), { ...data });

                await api.post("/rest/questionSet/winrar", data).then(({ data }) => {
                    console.log({ data })
                })

                console.log("data: ", data);
                

                message.success("Bilgiler güncellendi", 2);
                history.push('/questionSet')

            } else {
                id = nanoid(20)
                data.id = id
                let url 
                await api.post("/rest/questionSet/winrar", data).then(({ data }) => {
                    url = data
                })

                console.log("data: ", data);
                data.questionSetUrl = url 

                await setDoc(doc(firebaseDb, "questionSet", id), { ...data });
                message.success("Kayıt Başarılı bir şekilde eklendi.", 2);
                history.push('/questionSet')
            }
            console.log("data: ", data);
            await api.post("/rest/questionSet/answers", { correctAnswers: correctAnswers, id: id }).then(({ data }) => {
                console.log({ data })
            })

        }
    };
    const { Option } = Select;
    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Soru Setleri"}</h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to="/questionSet">
                        <Button className="button4" type="light" icon={<LeftOutlined />} size="large">GERİ</Button>
                    </Link>
                </div>
            </div>
            <div className="form-wrap">
                <Card title={id ? "Düzenle" : "Ekle"} loading={loading}>
                    <Form layout="horizontal" size={"large"} onFinish={save}>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                <Form.Item label="Dil" required help={errors.lang} validateStatus={errors.lang ? 'error' : 'success'}>
                                    <Select className="button4" defaultValue={(data.lang) ? data.lang : 'user'} style={{ width: 120 }} onChange={v => { setData({ ...data, lang: v }) }}>
                                        <Option value="TR">Türkçe</Option>
                                        < Option value="EN">İngilizce</Option>
                                        < Option value="DE">Almanca</Option>
                                        < Option value="AZ">Azerice</Option>
                                        < Option value="RU">Rusça</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                <Form.Item label="Başlık" required help={errors.name} validateStatus={errors.name ? 'error' : 'success'}>
                                    <Input className="button4" name="name" value={data.name} onChange={e => setData({ ...data, name: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                <Form.Item label="Sorular" required help={errors.questions} validateStatus={errors.questions ? 'error' : 'success'}>
                                    {answers > 0 &&
                                        <Alert type="info" message="Bu ankete en az bir cevap verildiği için düzenleyemezsiniz!" banner />
                                    }
                                    <MediaWithQuestionsInput className="button4" name='questions' record={data} setRecord={setData} disabled={answers > 0 ? true : false} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col span={24}>
                                <Form.Item>
                                    <Button className="button4" type="primary" disabled={loading} htmlType="submit" size="large" block > KAYDET </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </div>
        </div>
    );
};
export default QuestinSetDetail;
